/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ScheduledTransactionsResponse,
  (requestParams: vp.ScheduledTransactionsRequest) => void,
  () => void,
  (requestParams: vp.ScheduledTransactionsRequest) => Promise<vp.ScheduledTransactionsResponse>,
];

function useFetchScheduledTransactions({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.ScheduledTransactionsRequest>();
  const [response, setResponse] = useState<vp.ScheduledTransactionsResponse>({
    ErrorMessage: '',
    Success: false,
    NumberOfRecords: 0,
    ScheduledTransactions: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.ScheduledTransactionsRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchScheduledTransactions(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.ScheduledTransactionsRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        NumberOfRecords: 0,
        ScheduledTransactions: {},
      });
    },
    async (requestParams: vp.ScheduledTransactionsRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.fetchScheduledTransactions(requestParams, source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchScheduledTransactions);
